import NotificationController from '../../common/notification-modal.controller';
import template from '../../common/notification-modal.html';

class SendReportController {

  constructor($uibModalInstance, $rootScope, $scope, LoadedModel, $uibModal) {
    this._$rootScope = $rootScope;
    this._$uibModal = $uibModal;
    this._$scope = $scope;
    this.model = LoadedModel;
    // this.model.email = '';
    // this.model.name = '';
    // this.model.company = '';
    // this.model.phone = '';
    // this.model.userLastName = '';
    // this.model.phoneCode = '';
    // this.model.addNumber = false;
    this._$uibModalInstance = $uibModalInstance;
    this._captchaValidate = () => Promise.reject();
  }

  onCaptchaInit(validate) {
    this._captchaValidate = validate;
  }


  openModal(message) {
    this._$uibModal.open({
      animation: false,
      template: template,
      controllerAs: '$ctrl',
      size: 'sm',
      resolve: {
        message: function () {
          return message;
        }
      },
      controller: NotificationController,
    });
  }

  ok(form) {
    if (form.$valid) {
      this._captchaValidate().then(() => {
        this.requestInProgress = this.model.requestInProgress = true;
        this._$rootScope.$broadcast('solverStarted', 'report');
        this._$uibModalInstance.close();
        const timeStamp = this.model.uuid();
        this.model.saveUserDetails();
        this.model.getProgress(timeStamp, 'report', true);
        this.model.sendReport(timeStamp);
        this._$rootScope.$$listeners['sendReportData'] = [];
        this._$rootScope.$on('sendReportData', (event, result) => {
          if (result.notification === 'yes') {
            this.openModal('Report was sent. We will contact you soon.');
          } else {
            this.openModal('Report was sent.');
          }
        });
      }, () => this.catpchaIsInvalid  = true);
    }
  }

  cancel() {
    this._$uibModalInstance.dismiss('cancel');
  }
}

SendReportController.$inject = ['$uibModalInstance', '$rootScope', '$scope', 'LoadedModel', '$uibModal'];

export default SendReportController;



// WEBPACK FOOTER //
// ./client/app/components/report/send-report-modal.controller.js